(function () {
  if (window.fwccInstalled) return;
  window.fwccInstalled = true;

  var MAX_FILES = 3;
  var MAX_BYTES = 8 * 1024 * 1024;
  var TIMEOUT_MS = 20000;

  function init(root) {
    var form = root.querySelector('form');
    var auto = root.querySelector('[data-fwcc-autofocus]');
    if (auto) { auto.focus(); auto.scrollIntoView({ block: 'center' }); }
    if (!form || !root.querySelector('[data-fwcc-fields]')) return;

    var webhook = (root.getAttribute('data-fwcc-webhook') || '').trim();
    var fields = root.querySelector('[data-fwcc-fields]');
    var done = root.querySelector('[data-fwcc-done]');
    var errorBox = root.querySelector('[data-fwcc-error]');
    var submit = root.querySelector('[data-fwcc-submit]');
    var fileInput = root.querySelector('input[type=file][data-key]');
    var sending = false;
    var startedAt = Date.now();

    function showError(msg, focusEl) {
      errorBox.textContent = msg;
      errorBox.hidden = false;
      if (focusEl) focusEl.focus();
    }

    function validate() {
      errorBox.hidden = true;
      var invalid = Array.prototype.find.call(form.querySelectorAll('[required]'), function (el) { return !el.checkValidity(); });
      if (invalid) {
        var label = form.querySelector('label[for="' + invalid.id + '"]');
        var name = label ? label.firstChild.textContent.trim() : 'This field';
        var msg = invalid.type === 'email' && invalid.value ? 'Please enter a valid email address.'
          : invalid.id === 'fwcc-idea' && invalid.value ? 'Tell us a little more about your idea (at least 10 characters).'
          : name + ' is required.';
        showError(msg, invalid);
        return false;
      }
      if (fileInput && fileInput.files.length) {
        if (fileInput.files.length > MAX_FILES) { showError('Please attach up to ' + MAX_FILES + ' photos.', fileInput); return false; }
        for (var i = 0; i < fileInput.files.length; i++) {
          if (fileInput.files[i].size > MAX_BYTES) { showError('“' + fileInput.files[i].name + '” is larger than 8 MB.', fileInput); return false; }
        }
      }
      if (webhook && !turnstileToken()) {
        showError('Please complete the quick security check above the button.');
        return false;
      }
      return true;
    }

    function turnstileToken() {
      var el = form.querySelector('[name="cf-turnstile-response"]');
      return el ? el.value : '';
    }

    function payload() {
      var data = new FormData();
      form.querySelectorAll('[data-key]').forEach(function (el) {
        var key = el.getAttribute('data-key');
        if (el.type === 'file') {
          for (var i = 0; i < el.files.length; i++) data.append(key, el.files[i], el.files[i].name);
        } else {
          data.append(key, el.value.trim());
        }
      });
      data.append('turnstile_token', turnstileToken());
      data.append('elapsed_ms', String(Date.now() - startedAt));
      data.append('request_id', (window.crypto && crypto.randomUUID) ? crypto.randomUUID() : String(Date.now()));
      data.append('source', 'foldwow.com custom concept form');
      data.append('page_url', location.href);
      data.append('referrer', document.referrer || '');
      data.append('locale', document.documentElement.lang || '');
      data.append('submitted_at', new Date().toISOString());
      return data;
    }

    function success() {
      fields.hidden = true;
      done.hidden = false;
      done.focus();
      done.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (window.dataLayer) window.dataLayer.push({ event: 'custom_concept_submitted' });
    }

    // Fallback: regular Shopify contact form → email to the store address.
    function fallback() {
      if (fileInput) fileInput.disabled = true;
      sending = false;
      HTMLFormElement.prototype.submit.call(form);
    }

    form.addEventListener('submit', function (event) {
      if (form.querySelector('[name=fwcc_company]').value) { event.preventDefault(); success(); return; }
      if (!validate()) { event.preventDefault(); return; }
      if (!webhook) return; // native submit to Shopify
      event.preventDefault();
      if (sending) return;
      sending = true;
      submit.disabled = true;
      submit.classList.add('is-loading');

      var controller = window.AbortController ? new AbortController() : null;
      var timer = controller ? setTimeout(function () { controller.abort(); }, TIMEOUT_MS) : null;

      fetch(webhook, { method: 'POST', body: payload(), mode: 'cors', signal: controller ? controller.signal : undefined })
        .then(function (res) {
          clearTimeout(timer);
          if (!res.ok) throw new Error('HTTP ' + res.status);
          sending = false;
          success();
        })
        .catch(function () {
          clearTimeout(timer);
          fallback();
        });
    });
  }

  function boot() { document.querySelectorAll('[data-fwcc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
